<template>
  <v-card>
    <v-card-title>
      <v-icon left>{{ icon }}</v-icon>
      {{ title }}
      <span class="kv-path ml-2">{{ path }}</span>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showRaw = !showRaw" :color="showRaw ? 'primary' : ''">
        <v-icon>mdi-code-braces</v-icon>
      </v-btn>
      <v-btn icon @click="$emit('refresh')" :loading="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle
        v-if="error"
        class="error--text"
        align="left"
    >
      {{ error }}
    </v-card-subtitle>
    <v-card-text>
      <div v-if="!hasData && !error" class="kv-placeholder">
        (noch nicht geladen)
      </div>
      <pre v-else-if="showRaw" class="response-block">{{ rawJson }}</pre>
      <kv-tree v-else-if="hasData" :data="response"></kv-tree>
    </v-card-text>
  </v-card>
</template>

<script>
import KvTree from "./KvTree";

export default {
  name: "EndpointCard",
  components: { KvTree },
  props: {
    title: String,
    icon: String,
    path: String,
    response: { default: null },
    error: { default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    showRaw: false,
  }),
  computed: {
    hasData() {
      return this.response !== null && this.response !== undefined
    },
    rawJson() {
      try {
        return JSON.stringify(this.response, null, 2)
      } catch (e) {
        return String(this.response)
      }
    },
  },
}
</script>

<style scoped>
.kv-path {
  font-family: Consolas, "Courier New", monospace;
  font-size: 13px;
  color: #888;
  font-weight: normal;
}

.kv-placeholder {
  color: #666;
  font-style: italic;
  padding: 8px;
}

.response-block {
  background-color: #1e1e1e;
  color: #d4d4d4;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: Consolas, "Courier New", monospace;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-all;
  text-align: left;
}
</style>
